import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import SignIn from "./frontend/SignIn/SignIn";
import HomeScreen from "../src/frontend/HomeScreen/HomeScreen";
import RecruitmentForm from "./frontend/Recruitment/Applications/RecruitmentForm";
import ApplicationsSummary from "./frontend/Recruitment/Applications/HelperFunctions/ApplicationSummary";
import EnquiriesList from "./frontend/Enquiries/EnquiriesList";
import { auth } from "../src/backend/firebaseConfig";
import FileUpload from "./frontend/Accounts/PdfToCsv/FileUpload";
import Marketing from "./frontend/Marketing/Marketing";
import MembersHub from "./frontend/Compliance/MembersHub/MembersHub";
import { useLocation, useParams } from "react-router-dom";
import FileDirectory from "./frontend/Compliance/MembersHub/FileDirectory";
import MembersHubActivity from "./frontend/Compliance/MembersHub/Activity";
import AdviserDashboard from "./frontend/RecruitmentData/RecruitmentDashboard";
import GetAdviserAgencyCodes from "./frontend/Adviser/Components/AgencyCodes/GetAdviserAgencyCodes";
import GetAdviserReferences from "./frontend/Adviser/Components/References/GetAdviserReferences";
import ChatbotScreen from "./frontend/Compliance/Chatbot/ChatbotScreen";
import CachedResponsesDashboard from "./frontend/Compliance/Chatbot/AdminControls/CachedResponsesDashboard";
import PostcodeMap from "./frontend/Adviser/Components/PostcodeMap/PostcodeMap";
import "leaflet/dist/leaflet.css";
import AMLMonthlyDashboard from "./frontend/Accounts/AMLStatements.js/amlDashboard";
import ContactList from "./frontend/AdviserSupport/ContactList/ContactList";
import HighRiskCountries from "./frontend/Compliance/HighRiskCountries/HighRiskCountires";
import AdviserDirectory from "./frontend/Adviser/Pages/AdviserDirectory_temp";
import AdviserDetailsPage from "./frontend/Adviser/Pages/AdviserDetailsPage_temp";
import RegulatoryWordingUpdatesPage from "./frontend/Adviser/Pages/RegulatoryWordingUpdatesPage";
import MediaAnalyzerUploader from "./frontend/Marketing/Approvals/components/FinancialPromotions";
import AdminMediaPage from "./frontend/Marketing/Approvals/Approvals";
import NewFinancialPromotions from "./frontend/Marketing/Approvals/newSubmission/NewFinancialPromotions";
import { AdviserListProvider } from "./context/Adviser/Utils/AdviserEmailList";
import { AdviserListWithUnappointedProvider } from "./context/Adviser/Utils/UnappointedAppointedAdviserEmailList";
import DepartmentRouterPage from "./frontend/Departments/DepartmentRouterPage";
import AdministratorAccessPage from "./frontend/Administrator/AdministratorAccessPage";
import FirestoreCopyPage from "./frontend/Administrator/FirestoreCopyPage";
import SecretSantaPage from "./frontend/SecretSanta/SecretSantaPage";
import ParaplanningChargesPage from "./frontend/Accounts/Charges/Paraplanning/components/ChargesPage";
import EditAdviserDetailsPage from "./frontend/Adviser/Pages/EditAdviserDetailsPage";
import { LegacyClientAgreementRedirect } from "./frontend/Adviser/Tabs/ClientAgreement/ClientAgreement";
import EditAdviserCatchUpPage from "./frontend/Adviser/Tabs/AdviserCatchUp/EditAdviserCatchUpPage";
import AuditLogsPage from "./frontend/Adviser/AuditLogs/AuditLogsPage";
import ProviderNetworkPage from "./frontend/Compliance/ProviderNetwork/ProviderNetworkPage";
import AddProviderPage from "./frontend/Compliance/ProviderNetwork/AddProviderForm";
import ProviderDetailsPage from "./frontend/Compliance/ProviderNetwork/ProviderDetailsPage";
import ParaplanningDashboard from "./frontend/Paraplanning/Dashboard/ParaplanningDashboard";
import ParaplanningChargesViewOnly from "./frontend/Paraplanning/Dashboard/ParaplanningChargesViewOnly";
import ProviderIssueReportsPage from "./frontend/Compliance/ProviderNetwork/ProviderIssueReportsPage";
import ProCedingChargesPage from "./frontend/Accounts/ProCedingStatements/ProCedingChargesPage";
import NewAnnouncementPage from "./frontend/Marketing/Announcements/pages/NewAnnouncementPage";
import AnnouncementsPage from "./frontend/Marketing/Announcements/pages/AnnouncementsPage";
import StaffHolidayDashboard from "./frontend/StaffHoliday/StaffHolidayDashboard";
import StaffHolidayRequestForm from "./frontend/StaffHoliday/StaffHolidayRequestForm";
import StaffHolidayApprovalsPage from "./frontend/StaffHoliday/StaffHolidayApprovalsPage";
import StaffHolidayTrackerPage from "./frontend/StaffHoliday/StaffHolidayTrackerPage";
import StaffHolidayImportPage from "./frontend/StaffHoliday/StaffHolidayImportPage";
import ParaplanningSalariesPage from "./frontend/Paraplanning/components/ParaplanningSalaryUploadPage";
import FinancialPromotionContentGenerator from "./frontend/Marketing/FinancialPromotionContentGenerator/components/FinancialPromotionContentGenerator";
import FinancialPromotionResponsesDashboard from "./frontend/Marketing/FinancialPromotionContentGenerator/components/FinancialPromotionResponsesDashboard";
import "./css/index.css";
import { APP_ROUTES } from "./constants/appRoutes";
import FinancialPromotionResponseDetails from "./frontend/Marketing/FinancialPromotionContentGenerator/components/FinancialPromotionResponseDetails";
import EditLicenseCertificatesPage from "./frontend/Adviser/Tabs/LicenseCertificates/Pages/EditLicenseCertificatesPage";
import LicenseCertificatesBulkUploadPage from "./frontend/Adviser/Tabs/LicenseCertificates/Pages/LicenseCertificatesBulkUploadPage";
import LicenseCertificatesSummaryPage from "./frontend/Adviser/Tabs/LicenseCertificates/Pages/LicenseCertificatesSummaryPage";
import CpdRecordsPage from "./frontend/Adviser/Tabs/LicenseCertificates/Pages/CpdRecordsPage";
import RatesSummaryPage from "./frontend/Accounts/Rates/RatesSummaryPage";
import RatesBulkUploadPage from "./frontend/Adviser/Tabs/Rates/RatesBulkUploadPage";
import EditRatesPage from "./frontend/Adviser/Tabs/Rates/EditRatesPage";
import EditGroupBankDetailsPage from "./frontend/Adviser/Tabs/Rates/EditGroupBankDetailsPage";
import EditIODetailsPage from "./frontend/Adviser/Tabs/IODetails/EditIODetailsPage";
import IOBulkUploadPage from "./frontend/Adviser/Tabs/IODetails/IOBulkUploadPage";
import AdviserGatingPage from "./frontend/Adviser/Tabs/IODetails/AdviserGatingPage";
import MarketingWebsitesDashboard from "./frontend/Marketing/MarketingDashabord/pages/MarketingWebsitesDashboard";
import WebsiteEntryPage from "./frontend/Marketing/MarketingDashabord/pages/WebsiteEntryPage";
import PrintingChargeEntryPage from "./frontend/Marketing/MarketingDashabord/pages/PrintingChargeEntryPage";
import EmailLicenceEntryPage from "./frontend/Marketing/MarketingDashabord/pages/EmailLicenceEntryPage";
import PlanTypeMappingPage from "./frontend/Compliance/PlanTypeMapping/PlanTypeMappingPage";
import ComplianceReportsPage from "./frontend/Compliance/Reports/ComplianceReportsPage";
import ClientAgreementFeeStructuresPage from "./frontend/Compliance/ClientAgreementFeeStructures/ClientAgreementFeeStructuresPage";
import EditPlanTypeMappingPage from "./frontend/Compliance/PlanTypeMapping/EditPlanTypeMappingPage";
import { useUserPermissions } from "./frontend/SignIn/UserPermissionsContext";
import ReferencingWorkspacePage from "./frontend/Recruitment/Referencing/ReferencingWorkspacePage";
import ContractDraftingPage from "./frontend/Recruitment/ContractDrafting/ContractDraftingPage";
import CommissionSplitEventsDashboard from "./frontend/Accounts/CommissionSplits/CommissionSplitEventsDashboard";
import FCIStatementsPage from "./frontend/Accounts/FCIStatements/FCIStatementsPage";
import LiveFCIStatementsPage from "./frontend/Accounts/FCIStatements/LiveFCIStatementsPage";
import ProviderMatchesPage from "./frontend/Accounts/ProviderMatches/ProviderMatchesPage";
import FeesPaidPage from "./frontend/Accounts/CollectFees/CollectFeesPage";
import MonthlyPayments from "./frontend/Accounts/MonthlyPayments/pages/MonthlyPayments";
import ChargesBreakdown from "./frontend/Accounts/MonthlyPayments/pages/ChargesBreakdown";
import AdviserChargeBreakdown from "./frontend/Accounts/MonthlyPayments/pages/AdviserChargeBreakdown";
import AdviserChargePage from "./frontend/Accounts/MonthlyPayments/pages/AdviserChargePage";
import AdviserPaymentPage from "./frontend/Accounts/MonthlyPayments/pages/AdviserPaymentPage";
import { AdviserChargesProvider } from "./frontend/Accounts/MonthlyPayments/context/AdviserChargesContext";
import Guidelines from "./frontend/Accounts/MonthlyPayments/pages/Guidelines";
import GroupDetailsPage from "./frontend/GroupDetails/GroupDetailsPage";

const PING_INTERVAL = 300000; // Every 5 minutes (300,000 ms)

const keepServerAwake = () => {
  fetch("https://rosemount-staff.onrender.com/api/status")
    .then(() => {
      // console.log("Pinged Render API to keep it awake");
    })
    .catch((err) => {
      // console.error("Ping failed:", err);
    });
  fetch("https://compliance-chatbot.onrender.com/api/status")
    .then(() => {
      // console.log("Pinged Render API to keep it awake");
    })
    .catch(() => {
      // console.log("Ping failed, but will retry in 5 mins");
    });
};

// Protected Route Component
const ProtectedRoute = ({ user, children }) => {
  if (!user) {
    // console.log("No user found. Redirecting to Sign-In...");
    return <Navigate to="/" replace />;
  }

  return children;
};

const LegacyMarketingWebsiteRedirect = () => {
  const { websiteId } = useParams();
  return (
    <Navigate
      to={APP_ROUTES.MARKETING_WEBSITE_DETAILS.replace(":websiteId", websiteId)}
      replace
    />
  );
};

function App() {
  // useEffect(() => {
  //   keepServerAwake(); // Ping once when the component mounts
  //   const interval = setInterval(keepServerAwake, PING_INTERVAL);
  //   return () => clearInterval(interval); // Cleanup interval on unmount
  // }, []);

  const [user, setUser] = useState(null); // Track the authenticated user
  const [loading, setLoading] = useState(true); // Show loading until Firebase restores the session
  const { userPermissions = [] } = useUserPermissions();

  useEffect(() => {
    // Listen for auth state changes
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setUser(user); // Set the user in state
      setLoading(false); // Loading is complete once auth state is determined
    });

    return () => unsubscribe(); // Cleanup listener on unmount
  }, []);

  if (loading) {
    // Show a loading indicator while Firebase initializes
    return <div>Loading...</div>;
  }

  return (
    <Router
      future={{
        v7_relativeSplatPath: true,
        v7_startTransition: true,
      }}
    >
      <Routes>
        <Route path={APP_ROUTES.SECRET_SANTA} element={<SecretSantaPage />} />
        <Route path="/audit-logs" element={<AuditLogsPage />} />
        <Route path="/" element={<SignIn />} />
        <Route
          path={APP_ROUTES.CHARGES_BREAKDOWN_ADVISER_PAYMENT}
          element={
            <ProtectedRoute user={user}>
              <AdviserChargesProvider>
                <AdviserPaymentPage />
              </AdviserChargesProvider>
            </ProtectedRoute>
          }
        />
        <Route
          path={APP_ROUTES.CHARGES_BREAKDOWN_ADVISER_CHARGE}
          element={
            <ProtectedRoute user={user}>
              <AdviserChargesProvider>
                <AdviserChargePage />
              </AdviserChargesProvider>
            </ProtectedRoute>
          }
        />
        <Route
          path={APP_ROUTES.CHARGES_BREAKDOWN_ADVISER}
          element={
            <ProtectedRoute user={user}>
              <AdviserChargesProvider>
                <AdviserChargeBreakdown />
              </AdviserChargesProvider>
            </ProtectedRoute>
          }
        />
        <Route
          path={APP_ROUTES.CHARGES_BREAKDOWN}
          element={
            <ProtectedRoute user={user}>
              <AdviserChargesProvider>
                <ChargesBreakdown />
              </AdviserChargesProvider>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Home"
          element={
            <ProtectedRoute user={user}>
              <HomeScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Applications"
          element={
            <ProtectedRoute user={user}>
              <ApplicationsSummary />
            </ProtectedRoute>
          }
        />
        <Route
          path="/FinancialPromotions"
          element={
            <ProtectedRoute user={user}>
              <AdminMediaPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/advisers/:adviserKey/edit"
          element={<EditAdviserDetailsPage />}
        />
        <Route
          path="/advisers/:adviserKey/catch-up/edit"
          element={<EditAdviserCatchUpPage />}
        />
        <Route
          path="/advisers/:adviserKey/client-agreement/edit"
          element={<LegacyClientAgreementRedirect />}
        />
        <Route
          path="/advisers/:adviserKey/io-details/edit"
          element={<EditIODetailsPage />}
        />
        <Route
          path={APP_ROUTES.INTELLIFLO_ADVISER_GATING}
          element={<AdviserGatingPage />}
        />
        <Route
          path={APP_ROUTES.INTELLIFLO_IO_ID_BULK_UPLOAD}
          element={<IOBulkUploadPage />}
        />
        <Route
          path="/advisers/io-details/gating"
          element={
            <Navigate to={APP_ROUTES.INTELLIFLO_ADVISER_GATING} replace />
          }
        />
        <Route
          path="/advisers/io-details/bulk-upload"
          element={
            <Navigate to={APP_ROUTES.INTELLIFLO_IO_ID_BULK_UPLOAD} replace />
          }
        />
        <Route
          path="/FinancialPromotions/new"
          element={
            <ProtectedRoute user={user}>
              <AdviserListProvider>
                <NewFinancialPromotions />
              </AdviserListProvider>
            </ProtectedRoute>
          }
        />
        <Route
          path={APP_ROUTES.SOCIAL_MEDIA_CONTENT_CREATION}
          element={
            <ProtectedRoute user={user}>
              <AdviserListProvider>
                <FinancialPromotionContentGenerator />
              </AdviserListProvider>
            </ProtectedRoute>
          }
        />
        <Route
          path={APP_ROUTES.SOCIAL_MEDIA_CONTENT_MANAGEMENT}
          element={
            <ProtectedRoute user={user}>
              <AdviserListProvider>
                <FinancialPromotionResponsesDashboard />
              </AdviserListProvider>
            </ProtectedRoute>
          }
        />
        <Route
          path={APP_ROUTES.SOCIAL_MEDIA_CONTENT_RESPONSE_DETAIL}
          element={<FinancialPromotionResponseDetails />}
        />
        {/* <Route
          path="/FinancialPromotions/content-generator/:submissionId"
          element={
            <ProtectedRoute user={user}>
              
              <FinancialPromotionResponsesDashboard />
            </ProtectedRoute>
          }
        /> */}
        <Route
          path="/FinancialPromotions/:userEmail/:submissionId"
          element={
            <ProtectedRoute user={user}>
              <AdminMediaPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Enquiries"
          element={
            <ProtectedRoute user={user}>
              <EnquiriesList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Applications/:uid"
          element={
            <ProtectedRoute user={user}>
              <RecruitmentForm />
            </ProtectedRoute>
          }
        />
        <Route
          path={APP_ROUTES.RECRUITMENT_REFERENCING}
          element={
            <ProtectedRoute user={user}>
              <ReferencingWorkspacePage />
            </ProtectedRoute>
          }
        />
        <Route
          path={APP_ROUTES.RECRUITMENT_CONTRACT_DRAFTING}
          element={
            <ProtectedRoute user={user}>
              <ContractDraftingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={APP_ROUTES.CONVERT_COMMISSION_STATEMENTS}
          element={
            <ProtectedRoute user={user}>
              <FileUpload />
            </ProtectedRoute>
          }
        />
        <Route
          path={APP_ROUTES.FCI_REPORTS}
          element={
            <ProtectedRoute user={user}>
              <FCIStatementsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={APP_ROUTES.LIVE_FCI_STATEMENTS}
          element={
            <ProtectedRoute user={user}>
              <LiveFCIStatementsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={APP_ROUTES.PROVIDER_MATCHES}
          element={
            <ProtectedRoute user={user}>
              <ProviderMatchesPage />
            </ProtectedRoute>
          }
        />
        {/* <Route path="*" element={<Navigate to="/" />} /> */}
        <Route
          path="/Marketing"
          element={
            <ProtectedRoute user={user}>
              <Marketing />
            </ProtectedRoute>
          }
        />
        <Route
          path="/MembersHub"
          element={
            <ProtectedRoute user={user}>
              <FileDirectory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/MembersHub/:folderName/*"
          element={
            <ProtectedRoute user={user}>
              <MembersHub key={useLocation.pathname} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/MembersHub/Activity"
          element={
            <ProtectedRoute user={user}>
              <MembersHubActivity />
            </ProtectedRoute>
          }
        />
        <Route
          path="/RecruitmentDashboard"
          element={
            <ProtectedRoute user={user}>
              <AdviserDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/RecruitmentDashboard/RequestAgencyCodes/:docId"
          element={
            <ProtectedRoute user={user}>
              <GetAdviserAgencyCodes />
            </ProtectedRoute>
          }
        />
        <Route
          path="/RecruitmentDashboard/RequestReferences/:docId"
          element={
            <ProtectedRoute user={user}>
              <GetAdviserReferences />
            </ProtectedRoute>
          }
        />
        <Route
          path="/1-AIN"
          element={
            <ProtectedRoute user={user}>
              <ChatbotScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="/1-AINHistory"
          element={
            <ProtectedRoute user={user}>
              <CachedResponsesDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path={APP_ROUTES.GROUP_DETAILS}
          element={
            <ProtectedRoute user={user}>
              <GroupDetailsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/AdviserMap"
          element={
            <ProtectedRoute user={user}>
              <PostcodeMap />
            </ProtectedRoute>
          }
        />
        {/* <Route
          path="/AMLStatements"
          element={
            <ProtectedRoute user={user}>
              <AMLMonthlyDashboard />
            </ProtectedRoute>
          }
        /> */}
        <Route
          path="/check²/Statements"
          element={
            <ProtectedRoute user={user}>
              <AMLMonthlyDashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ContactList"
          element={
            <ProtectedRoute user={user}>
              {["In House Advisers", "Holiday Only", "Staff Holidays"].some(
                (permission) => userPermissions.includes(permission),
              ) ? (
                <Navigate to="/Department/AllStaff" replace />
              ) : (
                <ContactList />
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/HighRiskCountries"
          element={
            <ProtectedRoute user={user}>
              <HighRiskCountries />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Advisers"
          element={
            <ProtectedRoute user={user}>
              <AdviserDirectory />
            </ProtectedRoute>
          }
        />
        <Route
          path={APP_ROUTES.ADVISER_REGULATORY_WORDING_UPDATES}
          element={
            <ProtectedRoute user={user}>
              <RegulatoryWordingUpdatesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={`${APP_ROUTES.MONTHLY_PAYMENTS}/:tab?`}
          element={
            <ProtectedRoute user={user}>
              <MonthlyPayments />
            </ProtectedRoute>
          }
        />
        <Route
          path={APP_ROUTES.Guidelines}
          element={
            <ProtectedRoute user={user}>
              <Guidelines />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" />} />
        <Route
          path="/Department/:departmentKey"
          element={<DepartmentRouterPage />}
        />
        <Route
          path="/advisers/:adviserKey"
          element={
            <ProtectedRoute user={user}>
              <AdviserDetailsPage />
            </ProtectedRoute>
          }
        ></Route>
        <Route
          path="/Administrator/AccessOverview"
          element={<AdministratorAccessPage />}
        />
        <Route
          path={APP_ROUTES.FIRESTORE_COLLECTION_COPY}
          element={
            <ProtectedRoute user={user}>
              <FirestoreCopyPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/paraplanning-charges"
          element={
            <ProtectedRoute user={user}>
              <ParaplanningChargesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/provider-index/"
          element={
            <ProtectedRoute user={user}>
              <ProviderNetworkPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/provider-index/add"
          element={
            <ProtectedRoute user={user}>
              <AddProviderPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/paraplanning/charges-view"
          element={<ParaplanningChargesViewOnly />}
        />
        <Route
          path="/provider-index/edit/:providerId"
          element={
            <ProtectedRoute user={user}>
              <AddProviderPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/provider-index/:providerId"
          element={
            <ProtectedRoute user={user}>
              <ProviderDetailsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/paraplanning"
          element={
            <ProtectedRoute user={user}>
              <AdviserListWithUnappointedProvider>
                <ParaplanningDashboard />
              </AdviserListWithUnappointedProvider>
            </ProtectedRoute>
          }
        />
        <Route
          path="/paraplanning-salaries"
          element={
            <ProtectedRoute user={user}>
              <ParaplanningSalariesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/provider-index/issue-reports"
          element={
            <ProtectedRoute user={user}>
              <ProviderIssueReportsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/pro-ceding-statements"
          element={
            <ProtectedRoute user={user}>
              <ProCedingChargesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/department/marketing/announcements"
          element={
            <ProtectedRoute user={user}>
              <AnnouncementsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/department/marketing/announcements/new"
          element={
            <ProtectedRoute user={user}>
              <NewAnnouncementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/department/marketing/announcements/:announcementId"
          element={
            <ProtectedRoute user={user}>
              <NewAnnouncementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={APP_ROUTES.MARKETING_WEBSITES}
          element={
            <ProtectedRoute user={user}>
              <MarketingWebsitesDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/department/marketing/websites"
          element={<Navigate to={APP_ROUTES.MARKETING_WEBSITES} replace />}
        />
        <Route
          path="/department/marketing/websites/new"
          element={<Navigate to={APP_ROUTES.MARKETING_WEBSITE_NEW} replace />}
        />
        <Route
          path="/department/marketing/websites/:websiteId"
          element={<LegacyMarketingWebsiteRedirect />}
        />
        <Route
          path={APP_ROUTES.MARKETING_WEBSITE_NEW}
          element={
            <ProtectedRoute user={user}>
              <WebsiteEntryPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={APP_ROUTES.MARKETING_WEBSITE_DETAILS}
          element={
            <ProtectedRoute user={user}>
              <WebsiteEntryPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={APP_ROUTES.MARKETING_PRINTING_NEW}
          element={
            <ProtectedRoute user={user}>
              <PrintingChargeEntryPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={APP_ROUTES.MARKETING_PRINTING_DETAILS}
          element={
            <ProtectedRoute user={user}>
              <PrintingChargeEntryPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={APP_ROUTES.MARKETING_EMAIL_LICENCE_NEW}
          element={
            <ProtectedRoute user={user}>
              <EmailLicenceEntryPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={APP_ROUTES.MARKETING_EMAIL_LICENCE_DETAILS}
          element={
            <ProtectedRoute user={user}>
              <EmailLicenceEntryPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/staff-holiday"
          element={
            <ProtectedRoute user={user}>
              <StaffHolidayDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/staff-holiday/request"
          element={
            <ProtectedRoute user={user}>
              <StaffHolidayRequestForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/staff-holiday/approvals"
          element={
            <ProtectedRoute user={user}>
              <StaffHolidayApprovalsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/staff-holiday/tracker"
          element={
            <ProtectedRoute user={user}>
              <StaffHolidayTrackerPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/staff-holiday/import"
          element={
            <ProtectedRoute user={user}>
              <StaffHolidayImportPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/advisers/:adviserKey/license-certificates/edit"
          element={<EditLicenseCertificatesPage />}
        />

        <Route
          path="/compliance/license-certificates/bulk-upload"
          element={<LicenseCertificatesBulkUploadPage />}
        />
        <Route
          path="/compliance/license-certificates/cpd-records"
          element={<CpdRecordsPage />}
        />
        <Route
          path="/advisers/licence-certificates/summary"
          element={<LicenseCertificatesSummaryPage />}
        />
        <Route path={APP_ROUTES.IFA_RATES} element={<RatesSummaryPage />} />
        <Route
          path={APP_ROUTES.COMMISSION_SPLIT_EVENTS}
          element={
            <ProtectedRoute user={user}>
              <CommissionSplitEventsDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path={APP_ROUTES.FEES_PAID}
          element={
            <ProtectedRoute user={user}>
              <FeesPaidPage />
            </ProtectedRoute>
          }
        />
        {/* <Route
          path={APP_ROUTES.IFA_RATES_BULK_UPLOAD}
          element={<RatesBulkUploadPage />}
        /> */}

        <Route
          path={APP_ROUTES.COMPLIANCE_REPORTS}
          element={
            <ProtectedRoute user={user}>
              <ComplianceReportsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={APP_ROUTES.CLIENT_AGREEMENT_FEE_STRUCTURES}
          element={<ProtectedRoute user={user}><ClientAgreementFeeStructuresPage /></ProtectedRoute>}
        />
        <Route
          path={`${APP_ROUTES.CLIENT_AGREEMENT_FEE_STRUCTURES}/:adviserKey/:category/edit`}
          element={<ProtectedRoute user={user}><ClientAgreementFeeStructuresPage edit /></ProtectedRoute>}
        />
        <Route
          path="/advisers/:adviserKey/client-agreement/fees/:category/edit"
          element={<ProtectedRoute user={user}><ClientAgreementFeeStructuresPage edit /></ProtectedRoute>}
        />
        <Route
          path={APP_ROUTES.PLAN_TYPE_MAPPING}
          element={
            <ProtectedRoute user={user}>
              <PlanTypeMappingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={APP_ROUTES.PLAN_TYPE_MAPPING_EDIT}
          element={
            <ProtectedRoute user={user}>
              <EditPlanTypeMappingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/compliance/plan-type-mapping"
          element={<Navigate to={APP_ROUTES.PLAN_TYPE_MAPPING} replace />}
        />
        <Route
          path="/compliance/plan-type-mapping/:planTypeId/edit"
          element={<Navigate to={APP_ROUTES.PLAN_TYPE_MAPPING} replace />}
        />
        <Route
          path="/advisers/:adviserKey/rates/edit"
          element={<EditRatesPage />}
        />
        <Route
          path="/advisers/:adviserKey/group-bank-details/edit"
          element={<EditGroupBankDetailsPage />}
        />
      </Routes>
    </Router>
  );
}

export default App;


